import React from 'react';

import { cssMap } from '@compiled/react';

import { Box, Flex } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import { ProjectPickerLayout } from '../../project-picker-layout/ProjectPickerLayout';

import { ProjectListSkeleton } from './ProjectListSkeleton';

const styles = cssMap({
	headerSkeleton: {
		marginBottom: token('space.075'),
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingLeft: token('space.150'),
	},
	createButtonSkeleton: {
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
	},
});

// 18

export const ProjectCreateButtonSkeleton = (): React.JSX.Element => (
	<Flex columnGap="space.100" alignItems="center" xcss={styles.createButtonSkeleton}>
		<Skeleton height="20px" width="20px" isShimmering />
		<Skeleton height="20px" width="120px" isShimmering />
	</Flex>
);

type ProjectPickerLoadingSkeletonProps = {
	testId?: string;
};
/**
 * A skeleton loader component that is to be used as the loading state for the Project Picker
 */
export const ProjectPickerLoadingSkeleton = ({
	testId,
}: ProjectPickerLoadingSkeletonProps): React.JSX.Element => {
	return (
		<ProjectPickerLayout
			testId={testId}
			createButton={<ProjectCreateButtonSkeleton />}
			showCreateButton
		>
			<Box xcss={styles.headerSkeleton}>
				<Skeleton height="15px" width="140px" isShimmering />
			</Box>
			<ProjectListSkeleton itemCount={5} />
		</ProjectPickerLayout>
	);
};
